const Header = () => {
    return (
        <header className="navbar pcoded-header navbar-expand-lg navbar-light header-dark">
        <div className="m-header">
          {/* MENU BURGER */}
          <a className="mobile-menu" id="mobile-collapse" href="#!"><span /></a>
          {/* LOGO */}
          <a href="/" className="b-brand">
            <img src="/images/fullLogoWhite.png" alt="" className="logo" height={60} />
            <img src="/images/fullLogoWhite.png" alt="" className="logo-thumb" />
          </a>
          {/* MENU POINTS IN VERSIONE MOBILE */}
          <a href="#!" className="mob-toggler">
            <i className="feather icon-more-vertical" />
          </a>
        </div>
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              {/* BARRA DI RICERCA */}
              <a href="#!" className="pop-search"><span className="material-symbols-outlined">search</span></a>
              <div className="search-bar">
                <input type="text" className="form-control border-0 shadow-none" placeholder="Search here" />
                <button type="button" className="close" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
            </li>
            
            <li>
              <div className="dropdown">
                {/* MENU NOTIFICHE */}
                <a className="dropdown-toggle" href="#" data-toggle="dropdown">
                  <span className="material-symbols-outlined">notifications</span>
                  <span className="badge badge-pill badge-danger">{/*COUNTER NOTIFICHE*/}</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right notification">
                  <div className="noti-head">
                    <h6 className="d-inline-block m-b-0">Notifications</h6>
                    <div className="float-right">
                      <a href="#!" className="m-r-10">mark as read</a>
                      <a href="#!">clear all</a>
                    </div>
                  </div>
                  {/* <ul className="noti-body">
                    <li className="n-title">
                      <p className="m-b-0">NEW</p>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img className="img-radius" src="/assets/images/user/avatar-1.jpg" alt="Generic placeholder image" />
                        <div className="media-body">
                          <p><strong>John Doe</strong><span className="n-time text-muted"><i className="icon feather icon-clock m-r-10" />5 min</span></p>
                          <p>New ticket Added</p>
                        </div>
                      </div>
                    </li>
                    <li className="n-title">
                      <p className="m-b-0">EARLIER</p>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img className="img-radius" src="/assets/images/user/avatar-2.jpg" alt="Generic placeholder image" />
                        <div className="media-body">
                          <p><strong>Joseph William</strong><span className="n-time text-muted"><i className="icon feather icon-clock m-r-10" />10 min</span></p>
                          <p>Prchace New Theme and make payment</p>
                        </div>
                      </div>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img className="img-radius" src="/assets/images/user/avatar-1.jpg" alt="Generic placeholder image" />
                        <div className="media-body">
                          <p><strong>Sara Soudein</strong><span className="n-time text-muted"><i className="icon feather icon-clock m-r-10" />12 min</span></p>
                          <p>currently login</p>
                        </div>
                      </div>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img className="img-radius" src="/assets/images/user/avatar-2.jpg" alt="Generic placeholder image" />
                        <div className="media-body">
                          <p><strong>Joseph William</strong><span className="n-time text-muted"><i className="icon feather icon-clock m-r-10" />30 min</span></p>
                          <p>Prchace New Theme and make payment</p>
                        </div>
                      </div>
                    </li>
                  </ul> */}
                  <div className="noti-footer">
                    <a href="#!">show all</a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </header>
    )
}
export default Header;